import { useDispatch } from 'react-redux';
import { EAssistantPhase, ISupportArticle } from '../../../../store/reducers/admin/assistant';
import { clearArticles, getHCArticles, updatePhase } from '../../../../store/actions/admin/assistant';
import Icon, { COLORS, ICONS } from '../../../general-ui/icon';
import Search from '../../../general-ui/search-bar/search';
import './help-center.scss';
import { useTypedSelector } from '../../../../store/reducers/use-typed-selector';
import Paging from '../../../general-ui/paging/paging';
import { useEffect, useState } from 'react';
import WaitingIndicator from '../../../general-ui/waiting-indicator/waiting-indicator';

const HelpCenter: React.FC = () => {
	const {
		AssistantReducer: {
			articles,
			loadingArticles
		}
	} = useTypedSelector(state => state);

	const dispatch = useDispatch();

	const [currentPage, setCurrentPage] = useState(1);
	const [maxPage, setMaxPage] = useState(1);
	const [pageSize] = useState(5);
	
	// clear the stored HC articles list
	const onClear = () => {
		dispatch(clearArticles());
	};

	// fetch articles by search value from Brandlive Zendesk Help Center API
	const handleSearch = (search: string) => {
		dispatch(getHCArticles(search));
	};

	// set the total page number value when articles are loaded into redux
	useEffect(() => {
		if(!loadingArticles)
			setMaxPage(Math.ceil(articles.length/pageSize));
	}, [articles, loadingArticles, pageSize]);
	
	return (
		<div className="help-center-container">
			<div className="help-center-header">
				<button className="no-style" onClick={() => dispatch(updatePhase(EAssistantPhase.MENU))}><Icon name={ICONS.ARROW_LEFT} size={16} color={COLORS.WHITE} /></button>
				<h4>Help center</h4>
			</div>
			<div className="help-center-body">
				<div className="search-bar">
					<p>How can we help you?</p>
					<Search onClear={onClear} placeholder={"Search for a topic"} onSearch={handleSearch}/>
				</div>
				<div className="search-results">
					{loadingArticles ? (
						<WaitingIndicator />
					) : (
						articles.map((article: ISupportArticle, index: number) => {
							if((index >= ((currentPage - 1) * pageSize)) && (index < (currentPage * pageSize))) {
								return (
									<div key={article.html_url} className="search-result">
										<a href={article.html_url} target="__blank" rel="noopener">{article.title}</a>
									</div>
								);
							}
						})
					)}
					{maxPage > 1 ? <Paging page={currentPage} setPage={setCurrentPage} totalPages={maxPage} /> : <></>}
				</div>
				<div className="popular-topics">
					<h6>Popular topics</h6>
					<a href="https://help.brand.live/hc/en-us/articles/360002948934-What-is-Brandlive-" target="__blank" rel="noopener">What is Brandlive?</a>
					<a href="https://help.brand.live/hc/en-us/articles/360002991174-Viewing-Events" target="__blank" rel="noopener"> Viewing Events</a>
					<a href="https://help.brand.live/hc/en-us/articles/360003063034-Creating-Events" target="__blank" rel="noopener">Creating Events</a>
					<a href="https://help.brand.live/hc/en-us/articles/360003090774-Creating-Courses" target="__blank" rel="noopener">Creating Courses</a>
					<a href="https://help.brand.live/hc/en-us/articles/360003093954-Planning-for-Production" target="__blank" rel="noopener">Planning For Production</a>
					<a href="https://help.brand.live/hc/en-us/articles/360003062134-Using-Audiences" target="__blank" rel="noopener">Using Audiences</a>
				</div>
			</div>
			<div className="help-center-footer">

			</div>
		</div>
	);
};

export default HelpCenter;